"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OptionButton = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _qa = require("../../utils/qa");
var _Button = require("../Button");
var _ButtonDropdown = require("../ButtonDropdown");
var _ConditionalWrapper = require("../ConditionalWrapper");
var _Tooltip = require("../Tooltip");
var _OptionButtonModule = _interopRequireDefault(require("./OptionButton.module.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const OptionButton = exports.OptionButton = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    children,
    iconLeftName,
    iconLeftType,
    type,
    isFluid,
    disabled,
    size,
    isLoading,
    menu,
    anchorPosition,
    onOptionSelect,
    onButtonClick,
    onMenuOpen,
    onMenuClose,
    ariaLabel,
    actionType,
    tooltip,
    classNames,
    clickAwayRef,
    testId
  } = _ref;
  const [iconName, setIconName] = React.useState('chevron-down');
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: (0, _classify.default)(_OptionButtonModule.default.container, {
      [_OptionButtonModule.default.isFluid]: isFluid
    }, classNames?.wrapper),
    ref: ref,
    "data-testid": (0, _qa.generateTestId)({
      base: testId,
      slot: 'root'
    }),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ConditionalWrapper.ConditionalWrapper, {
      condition: Boolean(tooltip?.baseButton),
      wrapper: children => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.Tooltip, {
        ...tooltip?.baseButton,
        hidden: isMenuOpen ? true : tooltip?.optionsButton?.hidden,
        testId: (0, _qa.generateTestId)({
          base: testId,
          slot: 'base-tooltip'
        }),
        children: children
      }),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
        iconLeftName: iconLeftName,
        iconLeftType: iconLeftType,
        onClick: onButtonClick,
        size: size,
        type: type,
        disabled: disabled,
        isFluid: isFluid,
        ariaLabel: ariaLabel,
        actionType: actionType,
        isLoading: isLoading,
        classNames: {
          wrapper: (0, _classify.default)(_OptionButtonModule.default.leftButton, classNames?.baseButtonWrapper),
          icon: classNames?.baseButtonIcon
        },
        testId: (0, _qa.generateTestId)({
          base: testId,
          slot: 'base-button'
        }),
        children: children
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonDropdown.ButtonDropdown, {
      anchorPosition: anchorPosition,
      ariaLabel: ariaLabel,
      iconLeftName: iconName,
      tooltip: tooltip?.optionsButton,
      classNames: {
        buttonWrapper: (0, _classify.default)(_OptionButtonModule.default.rightButton, classNames?.optionsButtonWrapper),
        dropdownContainer: (0, _classify.default)(_OptionButtonModule.default.dropDownContainer, classNames?.dropdownContainer),
        buttonIcon: classNames?.optionsButtonIcon
      },
      type: type,
      disabled: disabled,
      menu: menu,
      onMenuClose: () => {
        setIconName('chevron-down');
        setIsMenuOpen(false);
        onMenuOpen?.();
      },
      onMenuOpen: () => {
        setIconName('chevron-up');
        setIsMenuOpen(true);
        onMenuClose?.();
      },
      onOptionSelect: onOptionSelect,
      size: size,
      clickAwayRef: clickAwayRef,
      testId: (0, _qa.generateTestId)({
        base: testId,
        slot: 'dropdown'
      })
    })]
  });
});